const FONT_FAMILY_ATTRIBUTE_REGEX = /font-family="(.*?)"/gi;
const FONT_FAMILY_QUOTE_OR_QUOTE_ENTITY_REGEX = /['"]|&apos;|&quot;/g;

/**
 * Rewrites every SVG `font-family` attribute to the bare family name.
 *
 * Text items hand fabric a quoted `fontFamily` (`'RasaRegular'`), which fabric copies into the attribute; since
 * 7.1.0-pmw-65 it XML-escapes the quotes as `&apos;` / `&quot;` on the way. The PDF generator registers its
 * fonts under the bare name and svg-to-pdfkit passes the attribute value straight to that lookup, so any
 * leftover quote, literal or escaped, makes the lookup miss and the text fall back to Helvetica.
 */
export const unquoteSvgFontFamilyAttributes = (svg: string): string => {
  return svg.replace(FONT_FAMILY_ATTRIBUTE_REGEX, (_match: string, familyValue: string): string => {
    return `font-family="${familyValue.replace(FONT_FAMILY_QUOTE_OR_QUOTE_ENTITY_REGEX, '').trim()}"`;
  });
};
